import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../../components/ui/dialog";
import { revokeSession } from "../../../api/platform";
import { DETAILS_A } from "./detailsA";
import { DETAILS_B } from "./detailsB";
import { DETAILS_C } from "./detailsC";
import { DetailToolbar } from "./DetailToolbar";
import { DetailTable } from "./DetailTable";
import { useDetailRows } from "./useDetailRows";

const BUILDERS = { ...DETAILS_A, ...DETAILS_B, ...DETAILS_C };

// Full-detail dialog opened from any system health card.
export const SystemDetailDialog = ({ section, data, onClose, onChanged }) => {
  const { t } = useTranslation();
  const build = section ? BUILDERS[section] : null;
  const detail = build && data ? build(data, t) : null;
  const state = useDetailRows(detail, section);

  const kill = async (userId) => {
    await revokeSession(userId);
    toast.success(t("system.sessionKilled"));
    onChanged?.();
    onClose();
  };

  return (
    <Dialog open={Boolean(detail)} onOpenChange={(open) => (open ? null : onClose())}>
      <DialogContent
        className="flex max-h-[92vh] w-[96vw] max-w-6xl flex-col gap-3 overflow-hidden rounded-3xl border-border/60"
        data-testid="system-detail-dialog"
      >
        {detail ? (
          <>
            <DialogHeader>
              <DialogTitle className="text-base font-black">{detail.title}</DialogTitle>
            </DialogHeader>

            <div className="grid grid-cols-2 gap-2.5 sm:grid-cols-4" data-testid="detail-summary">
              {detail.summary.map(([label, value], i) => (
                <div key={`${label}-${i}`} className="rounded-2xl bg-background p-3 shadow-neu-sm">
                  <p className="text-[10px] font-bold text-muted-foreground">{label}</p>
                  <p className="mt-1 font-mono text-base font-black num">
                    {value}
                  </p>
                </div>
              ))}
            </div>

            <DetailToolbar detail={detail} state={state} section={section} />

            <p className="text-xs font-bold text-muted-foreground" data-testid="detail-count">
              {t("system.rowsCount", { count: state.rows.length })}
            </p>

            <DetailTable detail={detail} state={state} onKill={kill} />
          </>
        ) : null}
      </DialogContent>
    </Dialog>
  );
};
